module.exports = __webpack_public_path__ + "media/12_14.f65c1dd6.wav";